import { PersonSerializer } from "@models/serializers/personSerializer.ts";
import { httpRequest } from "../../http";
import { Person } from "@models/person.model.ts";

export class CommandAddProfilePicture {
  async run(personId: number, file: File) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/person/${personId}/profile-picture/`;

    const form = new FormData();
    form.append('profile_picture', file, file.name)
    try {
      const response = await httpRequest<any>(url, { method: "POST", body: form });
      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): Person {
    const serializer = new PersonSerializer();
    return serializer.deserialize(data);
  }
}
